package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class RubriqueCompetenceState(
    val id: String,
    val sectionId: String,
    competence: String = "",
    niveau: Int = 0
) {
    var competence by mutableStateOf(competence)
    var niveau by mutableStateOf(niveau)

    val niveauLabel: String
        get() = when (niveau) {
            0 -> "Choisissez"
            1 -> "Débutant"
            2 -> "Intermédiaire"
            3 -> "Bien"
            4 -> "Très bien"
            5 -> "Excellent"
            else -> "Choisissez"
        }
}